<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Bayi"
    }
</script>

<style scoped>

</style>